import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import EditArea from './container/EditArea'
import ShowArea from './container/ShowArea'
import style from './style.module.less'

@inject('contentStore')
@observer
class CaseDetail extends Component {
  componentDidUpdate() {
    const { caseContent, contentStore } = this.props
    contentStore.setList(caseContent)
  }

  render() {
    const { caseImageTag, contentStore } = this.props

    return (
      <div
        onClick={() => {
          contentStore.setActive()
        }}
        className={style.caseDetail}
      >
        <div className={style.title}>
          <span className={style.key}>详情描述</span>
          <span className={style.value}>
            错误填写案例内容，可能会引起案例下架或流量减少，影响您的正常销售，请认真准确填写。
          </span>
        </div>
        <div className={style.container}>
          <ShowArea caseImageTag={caseImageTag} />
          <EditArea />
        </div>
      </div>
    )
  }
}

export default CaseDetail
